import * as React from "react";
import Heading from "backpack-ui/dist/components/heading";
var ArticleTitle = function (_a) {
    var children = _a.children;
    return (React.createElement(Heading, { level: 1, weight: "thick", size: "large" }, children));
};
export default ArticleTitle;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/articleTitle/index.tsx
// module id = UKmP
// module chunks = 3